<span id="upper-container">
  <app-npv-location-graph-filter-selector
    [viewByNode]="npvLocationVariables.viewByNode"
    [selectedLevelTab]="selectedLevelTab"
    [npvLocationChartData]="inverseChartData"
    [currentSelectedLocationNode]="npvLocationVariables.currentSelectedLocationNode"
    [currentSelectedOntologyNode]="npvLocationVariables.currentSelectedOntologyNode"
  ></app-npv-location-graph-filter-selector>
  <app-variable-container [variables]="addOnVariables" [showVariableMenu]="true"></app-variable-container>
</span>
<div [chart]="chartObject"></div>
<app-chart-legend [legends]="legends" [metricType]="MetricType.NewPatientVisits" [benchmarksToExclude]="['65th Percentile']">
</app-chart-legend>
<app-loader *ngIf="showLoader"></app-loader>
